import React, { useEffect, useState } from "react";
import Head from "next/head";
import { useMediaQuery } from "react-responsive";
import { Viewer360Desktop, Viewer360Mobile } from "@/app/components/LpYarisCross360";

/** Página do tour 360° do Yaris Cross. Desktop e mobile em componentes separados. */
const LpYarisCross360: React.FC = () => {
	const isDesktop = useMediaQuery({ minWidth: 769 });
	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	return (
		<>
			<Head>
				<title>Yaris Cross - Tour Virtual 360º</title>
				<meta name="description" content="Tour Virtual 360º - Yaris Cross" />
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1, viewport-fit=cover, user-scalable=no"
				/>
			</Head>
			{!isMounted ? (
				<Viewer360Mobile />
			) : isDesktop ? (
				<Viewer360Desktop />
			) : (
				<Viewer360Mobile />
			)}
		</>
	);
};

export default React.memo(LpYarisCross360);
